import TabsNavigation from "../../../../../components/elements/TabsNavigation";
import FreelancerList from ".";
import FreelancerCategory from "../FreelancerCategory";
import FreelancerTags from "../FreelancerTags";
import ManageFreelancer from "../../../../../components/sections/admin/Freelancer/ManageFreelancer";
import FreelancerProposal from "../FreelancerProposal";
import FreelanceEnquiry from "../FreelanceEnquiry";
import FreelanceBudget from "../FreelanceBudget";

const tabRoutes = [
  {
    label: "List",
    icon: "fa-regular fa-list",
    path: "/admin/freelancer-jobs",
  },
  {
    label: "Categories",
    icon: "fa-regular fa-layer-group",
    path: "/admin/freelancer-categories",
  },
  {
    label: "Tags",
    icon: "fa-regular fa-tags",
    path: "/admin/freelancer-tags",
  },
  {
    label: "Proposals",
    icon: "fa-regular fa-file-lines",
    path: "/admin/freelancer-proposals",
  },
  {
    label: "Budgets",
    icon: "fa-regular fa-display-chart-up-circle-currency",
    path: "/admin/freelance-budgets",
  },
  {
    label: "Enquiry",
    icon: "fa-regular fa-address-book",
    path: "/admin/freelance-enquiry",
  },
];

export const freelancerRoutes = () => [
  {
    path: "/admin/freelancer-jobs",
    component: () => (
      <TabsNavigation title="Freelancer Management" tabRoutes={tabRoutes}>
        <FreelancerList />
      </TabsNavigation>
    ),
    layout: "admin",
    routeType: "admin",
    title: "Freelancers Management",
  },
  {
    path: "/admin/freelancer-categories",
    component: () => (
      <TabsNavigation title="Freelancer Management" tabRoutes={tabRoutes}>
        <FreelancerCategory />
      </TabsNavigation>
    ),
    layout: "admin",
    routeType: "admin",
    title: "Freelancers Management",
  },
  {
    path: "/admin/freelancer-tags",
    component: () => (
      <TabsNavigation title="Freelancer Management" tabRoutes={tabRoutes}>
        <FreelancerTags />
      </TabsNavigation>
    ),
    layout: "admin",
    routeType: "admin",
    title: "Freelancers Management",
  },
  {
    path: "/admin/freelancer-proposals",
    component: () => (
      <TabsNavigation title="Freelancer Management" tabRoutes={tabRoutes}>
        <FreelancerProposal />
      </TabsNavigation>
    ),
    layout: "admin",
    routeType: "admin",
    title: "Freelancer Management",
  },
  {
    path: "/admin/freelance-enquiry",
    component: () => (
      <TabsNavigation title="Freelancer Management" tabRoutes={tabRoutes}>
        <FreelanceEnquiry />
      </TabsNavigation>
    ),
    layout: "admin",
    routeType: "admin",
    title: "Freelancer Management",
  },
  {
    path: "/admin/freelance-budgets",
    component: () => (
      <TabsNavigation title="Freelancer Management" tabRoutes={tabRoutes}>
        <FreelanceBudget/>
      </TabsNavigation>
    ),
    layout: "admin",
    routeType: "admin",
    title: "Freelancer Management",
  },
  {
    path: "/admin/manage-freelancer",
    component: ManageFreelancer,
    layout: "admin",
    routeType: "admin",
    title: "Manage Freelancer",
  },
  {
    path: `/admin/manage-freelancer/:id`,
    component: ManageFreelancer,
    layout: "admin",
    routeType: "admin",
    title: "Manage Freelancer",
  },
];
